import { render } from "./MobileTable.vue?vue&type=template&id=c1445f98&scoped=true"
import script from "./MobileTable.vue?vue&type=script&lang=js"
export * from "./MobileTable.vue?vue&type=script&lang=js"

import "./MobileTable.vue?vue&type=style&index=0&id=c1445f98&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c1445f98"

export default script